import { MessageCircle } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import DesignCTA from "@/components/DesignCTA";
import { SPORTS, TEAM_SPORTS, IMAGES, waLink, WHATSAPP_GENERIC } from "@/data/content";

const sportWa = (id) => waLink(SPORTS.find((s) => s.id === id)?.msg || WHATSAPP_GENERIC);

export default function TeamSports() {
  return (
    <>
      <PageHero
        testId="team-sports-hero"
        eyebrow="Product Range"
        title="Team Sports"
        sub="Beyond the rink: custom kits and teamwear for soccer, basketball, rugby, volleyball, baseball and more — made for clubs, leagues and organizations."
        img={IMAGES.soccerRun}
      />

      <section className="py-14 md:py-20" data-testid="team-sports-grid">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {TEAM_SPORTS.map((s, i) => (
              <Reveal key={s.id} delay={i * 0.05}>
                <div
                  id={s.id}
                  data-testid={`sport-card-${s.id}`}
                  className="scroll-mt-28 group bg-white rounded-lg border border-slate-200 overflow-hidden hover:border-ice/60 hover:shadow-lg transition-all duration-300"
                >
                  <div className="h-52 overflow-hidden">
                    <img src={s.img} alt={s.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                  </div>
                  <div className="p-6">
                    <h2 className="font-display font-semibold uppercase text-2xl text-navy">{s.name}</h2>
                    <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
                    <a
                      href={sportWa(s.id)}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`sport-quote-${s.id}`}
                      className="mt-5 link-accent"
                    >
                      <MessageCircle size={15} />
                      Discuss on WhatsApp
                    </a>
                  </div>
                </div>
              </Reveal>
            ))}
            <Reveal delay={0.25}>
              <div className="h-full bg-icelight border border-ice/30 rounded-lg p-6 flex flex-col justify-between min-h-[320px]" data-testid="sport-card-other">
                <div>
                  <h2 className="font-display font-semibold uppercase text-2xl text-navy">Another Sport?</h2>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                    Our production isn't limited to the sports listed here. If your team
                    plays it, talk to us — we'll advise how your kit can be made.
                  </p>
                </div>
                <a
                  href={waLink(WHATSAPP_GENERIC)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="sport-quote-other"
                  className="mt-6 btn-navy"
                >
                  <MessageCircle size={16} />
                  Tell us your sport
                </a>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <DesignCTA />
    </>
  );
}
